var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "ticketTagManage" } }, [
    _c(
      "div",
      { staticClass: "dialog-content" },
      [
        _vm.editing
          ? _c("div", { staticClass: "context" }, [
              _vm._v("To edit a ticket tag, edit the fields below.")
            ])
          : _c("div", { staticClass: "context" }, [
              _vm._v("To add a ticket tag, enter a name and description.")
            ]),
        _vm._v(" "),
        _c("v-text-field", {
          ref: "inputTitle",
          attrs: {
            "validate-on-blur":
              _vm.$refs.inputTitle && _vm.$refs.inputTitle.valid,
            rules: _vm.rules.title,
            label: "Title",
            "prepend-icon": "mdi-format-title"
          },
          model: {
            value: _vm.ticketTag.title,
            callback: function($$v) {
              _vm.$set(_vm.ticketTag, "title", $$v)
            },
            expression: "ticketTag.title"
          }
        }),
        _vm._v(" "),
        _c("v-text-field", {
          ref: "inputDescription",
          attrs: {
            "validate-on-blur":
              _vm.$refs.inputDescription && _vm.$refs.inputDescription.valid,
            rules: _vm.rules.description,
            "multi-line": "",
            "no-resize": "",
            rows: 2,
            label: "Description",
            "prepend-icon": "mdi-note-text"
          },
          model: {
            value: _vm.ticketTag.description,
            callback: function($$v) {
              _vm.$set(_vm.ticketTag, "description", $$v)
            },
            expression: "ticketTag.description"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "dialog-footer" },
      [
        _c(
          "v-btn",
          {
            staticClass: "button",
            attrs: { flat: "", color: "info" },
            on: {
              click: function($event) {
                _vm.routeRemoveQueries(["dialog", "dialogAction"])
              }
            }
          },
          [_vm._v("Cancel")]
        ),
        _vm._v(" "),
        _c(
          "v-btn",
          {
            staticClass: "button",
            attrs: { loading: _vm.lockout.on, flat: "", color: "primary" },
            on: {
              click: function($event) {
                _vm.editing ? _vm.save() : _vm.create()
              }
            }
          },
          [_vm._v(_vm._s(_vm.editing ? "Save" : "Create"))]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e4d2873", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e4d2873","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TicketTagManage.vue
// module id = 611
// module chunks = 4